// Image Slider

jQuery(document).ready(function(jQuery){
  jQuery('.slider-logos').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 3
      }
    }]
  });
});

// Slider with Dynamic Text

jQuery(document).ready(function($){
  jQuery(".slick-wrapper").slick({
    arrows:true,
    dots:true,
    cssEase: "ease-in-out",
    infinite:true,
    speed:1200,
    centerMode:true,
    draggable:true,
    variableWidth:true,
    slidesToShow:1,
    slidesToScroll:1,
    asNavFor: ".text-wrapper",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  });
  jQuery(".text-wrapper").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    fade: true,
    speed:1200,
    infinite:true,
    adaptiveHeight: true
  });
});
